module.exports = __webpack_public_path__ + "fx.png?3d9d2837025b73af1d1909e07b42dddb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fx.png
// module id = 392
// module chunks = 0